<template>
  <div class="">
    <div class=" px-2 py-3">
      <div class="border border-dark">
        <div class="p-1" style="height:85vh; background-color: white">

          <l-map  :zoom="zoom" :center="center" style="" ref="myMap">
            <l-tile-layer :url="url"></l-tile-layer>
            <l-control>
                <div>
                  <b-form-select  v-model="selectedCountry" class="" @change="ChangeCountry">
                    <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option  :value="3" v-if="this.cont">Greece</b-form-select-option>
                  </b-form-select>
                </div>
                <div>
                 <b-form-select  v-model="selectedYear" class="mt-1"  @change="ChangeYear">
                  <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                  </template>
                  <!-- These options will appear after the ones from 'options' prop-->
                  <b-form-select-option  v-for="(j,index) in yearArray"
                                        :key="index"
                                        :value="j" >{{j}}</b-form-select-option>
                </b-form-select>
              </div>
              <div>
                <b-form-select v-model="selected" class="mt-1" @change="ChangeWeek">
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Select Week --</b-form-select-option>
                      </template>
                      <b-form-select-option v-for="(item,index) in weeksArray" :key="index+'w_bar'" :value="'w'+item+'_bar'" >{{ item }} ({{ monthsArray[index] }})</b-form-select-option>
                </b-form-select>
              </div>
               <!-- <b-form-select v-if="selectedYear===2020"  v-model="selected" class="mb-3 col-6 ml-auto" @change="ChangeWeek">
                 
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Week --</b-form-select-option>
                  </template>
                
                  <b-form-select-option  :value="'w30_bar'" >30(July)</b-form-select-option>
                  <b-form-select-option  :value="'w32_bar'" >32(August)</b-form-select-option>
                  <b-form-select-option  :value="'w35_bar'" >35(August)</b-form-select-option>
                  <b-form-select-option  :value="'w38_bar'" >38(September)</b-form-select-option>
                </b-form-select>
                <b-form-select v-if="selectedYear===2021" v-model="selected" class="mb-3 col-6 ml-auto" @change="ChangeWeek">
              
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Week --</b-form-select-option>
                  </template>
              
                  <b-form-select-option  :value="'w26_bar'" >26(June)</b-form-select-option>
                  <b-form-select-option  :value="'w27_bar'" >27(June)</b-form-select-option>
                  <b-form-select-option  :value="'w28_bar'" >28(July)</b-form-select-option>
                  <b-form-select-option  :value="'w29_bar'" >29(July)</b-form-select-option>
                  <b-form-select-option  :value="'w30_bar'" >30(July)</b-form-select-option>
                  <b-form-select-option  :value="'w31_bar'" >31(August)</b-form-select-option>
                  <b-form-select-option  :value="'w32_bar'" >32(August)</b-form-select-option>
                  <b-form-select-option  :value="'w33_bar'" >33(August)</b-form-select-option>
                  <b-form-select-option  :value="'w34_bar'" >34(August)</b-form-select-option>
                </b-form-select>
                <b-form-select v-if="selectedYear===2022" v-model="selected" class="mb-3 col-6 ml-auto" @change="ChangeWeek">
                
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select Week --</b-form-select-option>
                    </template>
                  
                    <b-form-select-option  :value="'w22_bar'" >22(June)</b-form-select-option>
                    <b-form-select-option  :value="'w27_bar'" >27(July)</b-form-select-option>
                    <b-form-select-option  :value="'w31_bar'" >31(August)</b-form-select-option>
                    <b-form-select-option  :value="'w36_bar'" >36(September)</b-form-select-option>
                    
                  </b-form-select>-->
             
              <div class="p-2 mt-1 info-text">
                <p  style= "font-size:12px;"> Villages with increased risk for West Nile <br> Virus human cases at settlement level, <br>as produced by the BAR data-driven model.  </p>
              </div> 
              <div class="mt-3 rounded p-2" style="font: 14px/16px Arial, Helvetica, sans-serif; background: rgba(222, 222, 222, 0.9);">
                <div class="" v-if="selectedYear<2023">
                  <div style="display:block">
                    <div style="display:flex;align-items:center; margin-bottom:10px">
                      <div style="background-color:green; border-radius:10px;height:10px;width:10px;margin-right:5px;">
                      </div>
                      <strong> = Not expected WNV human cases</strong>
                    </div>
                    <div style="display:flex;align-items:center; ">
                      <div style="background-color:red; border-radius:10px;height:10px;width:10px;margin-right:5px;">
                      </div>
                      <strong> = Increased risk for WNV human cases</strong>
                    </div>
                  </div>
                </div>
                <div class="" v-if="selectedYear>2022">
                    <div style="display:block" class="">
                      <br>
                      <div style="text-align:center">
                        <strong>Risk levels for transmission of WNV to humans</strong>
                      </div>
                      <div style="display:flex" class="justify-content-center">
                        <div class="rounded-pill" style=" margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#bfbfbf"></div>
                        1
                        <br>
                        <div class="rounded-pill" style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#008000"></div>
                        2
                        
                        <div class="rounded-pill" style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#ffff00"></div>
                        3
                        
                        <div class="rounded-pill" style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#FFA500"></div>
                        4
                      
                        <div class="rounded-pill" style="margin-left:10px; margin-right:2px; height:12px; width:12px; margin-top: 2px; background-color:#ff0000"></div>
                        5
                        <br>
                      </div>
                      <br>
                      
                      
                    </div>
                  </div>
              </div>
              
            </l-control>
           
            <div v-if="tst" class="loader"></div>
            <div v-for="i in settlement_WNV_data" :key="i.x">
                <div v-if="i[selected]!==null">
                  <l-circle-marker ref="circle"
                            :lat-lng="[i.y, i.x]"
                            :color="selectedYear>2022? colorsAfter2023[Math.floor(i[selected]/25)]:colors[i[selected]]"
                            :fillColor="selectedYear>2022? colorsAfter2023[Math.floor(i[selected]/25)]:colors[i[selected]]"
                            :radius="5"
                            :weight="2"
                            v-on:mousemove="selectedYear>2022? settlementActive(i,Math.floor(i[selected]/25)):settlementActive(i,i[selected])">
                  <l-tooltip>{{nameOfSettlementTooltip}}</l-tooltip>
                  </l-circle-marker>
                </div>
              </div>

          </l-map>

        </div>
      </div>
    </div>
    <b-modal id="modal-center" v-model="modalError" centered title="Error" hide-footer>
      <p class="my-4">No Data Available</p>
    </b-modal>
  </div>


</template>


<script>
import {LMap, LTileLayer, LCircleMarker, LPolygon,LControl, LMarker,LTooltip} from 'vue2-leaflet';
import axios from '../axios-auth'
import routes from '../routes/routes'
export default {
  components: {
    LTooltip,
    LMap,
    LTileLayer,
    LCircleMarker,
    LControl,
  
  },
  data(){
    return{
      modalError:false,
      selectedYear:2025,
      yearArray:[2020,2021,2022,2023,2024,2025],
      weeksArray:[],
      monthsArray:[],
      nameOfSettlementTooltip:"",
      tst:true,
      settlement_WNV_data:'',
      selected:'w22_bar',
      selectedCountry:null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [43.6659, 17.1937],
      colors:['#00961f','#ff0000'],
      colorsAfter2023:['#bfbfbf','#008000','#FFFF00','#FFA500','#FF0000'],
      group:null,
      cont:false
    }
  },
  async created(){
    //const token = localStorage.getItem('token')
    //const settlement_WNV_data_all=await axios.get('humanCasesRisk/west-nile-virus/settlement/',{headers: { Authorization: `Bearer ${token}` }})
   // this.settlement_WNV_data=settlement_WNV_data_all.data
    //console.log(this.settlement_WNV_data)
    //this.weekArray=this.settlement_WNV_data.w30_bar
    var user =JSON.parse(localStorage.getItem('user'))
    this.group = user.groups
    this.cont=false
    for(var rr=0; rr<this.group.length; rr++){
      if(this.group[rr].name==='view_all'){
        this.cont=true
        break
      }
      if(this.group[rr].name==='EL'){
        this.cont=true
      }
    }
    if(this.cont){
      await this.RequestData(this.selectedYear)
    
      
      this.selectedCountry=3
    }else{
      this.modalError=true
    }
    this.tst=false
  },
  methods: {
    
    ChangeCountry() {
      if (this.selectedCountry === 4) {
        this.$refs.myMap.mapObject.fitBounds([[46.2634502432201, 12.0569594997323], [44.6924119881264, 11.1465820717025]])
      } else {
        this.$refs.myMap.mapObject.fitBounds([[40.7634502432201, 23.9569594997323], [35.8924119881264, 23.8465820717025]])
      }
    },
    ChangeWeek(){

    },
    ChangeYear(){
      //this.selected=
      if(this.selectedYear===2022){
        this.selected='w22_bar'
      }
      if(this.selectedYear===2021){
        this.selected='w26_bar'
      }
      if(this.selectedYear===2020){
        this.selected='w30_bar'
      }
      
      this.RequestData(this.selectedYear)
    },
    settlementActive(i,value){
        this.nameOfSettlementTooltip=i.settlement+" : "+value
    },
    getMonthFromWeek(weekNumber, year) {
      const date = new Date(year, 0, 1 + (weekNumber - 1) * 7);
      const options = { month: 'long' };
      const month = date.toLocaleString('en-US', options);
      return month;
    },
    async RequestData(year){
      this.tst=true
      const token = localStorage.getItem('token')
      const settlement_WNV_data_all=await axios.get('humanCasesRisk/west-nile-virus/settlement/',{
        headers: { Authorization: `Bearer ${token}` },
        params:{
          year:year,
        }
      })//////.catch(error=> routes.replace('/'))
      this.settlement_WNV_data=settlement_WNV_data_all.data
      var v=this
      v.weeksArray=[]
      v.monthsArray=[]
      for(var tt in v.settlement_WNV_data[0]){
          if(tt.includes('_bar')){
            
            tt=tt.split('_')[0]
            tt=tt.split('w')[1]
            const month = v.getMonthFromWeek(tt, v.selectedYear);
            console.log(tt)
           
            v.weeksArray.push(tt)
            v.monthsArray.push(month)
            console.log(v.monthsArray)
          }
      }
      v.selected='w'+v.weeksArray[0]+'_bar'
      console.log(v.selected)
      console.log(this.settlement_WNV_data)
      this.tst=false
    }

  }
}
</script>

<style>
.info-text{
background-color: rgb(0 148 138); 
color: white;
}

</style>


